import React, { Fragment } from "react";

import { TableExpandableCard } from "../../../../../../../components/table/components/TableExpandableCard";
import { DeviceNameCellMobile } from "../../../../../../../components/table";
import { DeviceWithType } from "../../../../../../../components/devices/DeviceWithType";
import { RequestedDevicesDropdownActions } from "../requestedDevicesDropdownActions";

export const TableCard = ({ type, identifier, manufacturer, name }) => {
  return (
    <TableExpandableCard
      showExpand={false}
      content={
        <Fragment>
          <DeviceNameCellMobile name={name} />
          <DeviceWithType type={type} identifier={identifier} />
          {manufacturer && (
            <div className={"color-table__cell"}>{manufacturer}</div>
          )}
        </Fragment>
      }
      aside={
        <RequestedDevicesDropdownActions
          identifier={identifier}
          name={name}
          type={type}
        />
      }
    />
  );
};
